module.exports = __webpack_public_path__ + "static/postIt01-8859d889c5d7e9a1d3c8c1feae2d16e3.svg";